import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { LqsPage } from "~/lqs/layout";
import { DigestionTopicCreateForm } from "./components/DigestionTopicCreateForm";

export function NewDigestionTopicPage() {
  return (
    <LqsPage title="New Digestion Topic">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <DigestionTopicCreateForm />
      </Container>
    </LqsPage>
  );
}
